module.exports = __webpack_public_path__ + "assets/img/3_1217_big.01748e4f.jpg";